import { render, staticRenderFns } from "./TableFooterControls.vue?vue&type=template&id=31c268be&scoped=true"
import script from "./TableFooterControls.vue?vue&type=script&lang=js"
export * from "./TableFooterControls.vue?vue&type=script&lang=js"
import style0 from "./TableFooterControls.vue?vue&type=style&index=0&id=31c268be&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c268be",
  null
  
)

export default component.exports